// src/components/clientes/ClientesMain.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import GerenciarClientes from '../superadmin/GerenciarClientes';
import GerenciarTodosUsuarios from '../superadmin/GerenciarTodosUsuarios';

/* ---- Ícones SVG ---- */
const CrownIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
        <path d="M2 19h20v2H2v-2zM2 6l5 9 5-9 5 9 5-9v11H2V6z" />
    </svg>
);
const BuildingIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
);
const UsersIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
);
const HomeIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
    </svg>
);
const LogoutIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" />
    </svg>
);
const ChevronIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const ClientesMain = ({ supabase, session, onLogout }) => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('clientes');
    const [menuOpen, setMenuOpen] = useState(false);
    const [mounted, setMounted] = useState(false);

    useEffect(() => { const t = setTimeout(() => setMounted(true), 60); return () => clearTimeout(t); }, []);

    const nomeUsuario = session?.user?.user_metadata?.nome || 'Super Admin';
    const emailUsuario = session?.user?.user_metadata?.email_real || session?.user?.email || '';
    const iniciais = nomeUsuario.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();

    const handleLogout = async () => {
        try {
            await onLogout();
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (!menuOpen) return;
        const close = () => setMenuOpen(false);
        document.addEventListener('click', close);
        return () => document.removeEventListener('click', close);
    }, [menuOpen]);

    return (
        <>
            <style>{`
                .cm-tab { cursor:pointer; padding:8px 18px; border-radius:9px; font-size:13px; font-weight:600;
                    display:flex; align-items:center; gap:8px; transition:all 0.2s; border:1px solid transparent; background:none;
                    color:#64748b; font-family:inherit; }
                .cm-tab:hover { color:#0f172a; background:#f1f5f9; }
                .cm-tab.active { color:#0A1F3A; background:rgba(10,31,58,0.07); border-color:rgba(10,31,58,0.15); }

                .cm-menu-item { display:flex; align-items:center; gap:10px; width:100%; padding:10px 14px; border-radius:10px;
                    font-size:13px; font-weight:500; color:#475569; background:none; border:none;
                    cursor:pointer; font-family:inherit; transition:all 0.15s; text-align:left; }
                .cm-menu-item:hover { background:#f1f5f9; color:#0f172a; }
                .cm-menu-item.danger { color:#ef4444; }
                .cm-menu-item.danger:hover { background:rgba(239,68,68,0.06); color:#dc2626; }

                @media (max-width: 640px) { .cm-nav-email { display: none; } }
            `}</style>

            <div style={{ minHeight: '100vh', background: '#f0f4f8', fontFamily: "'Inter', -apple-system, sans-serif" }}>

                {/* ── Navbar ── */}
                <header style={{ position: 'sticky', top: 0, zIndex: 50, background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', borderBottom: '1px solid #e8edf2' }}>
                    <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px', height: '64px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
                            <div style={{ display: 'inline-flex', alignItems: 'center', background: '#fff', borderRadius: '10px', padding: '5px 14px', border: '1px solid #e8edf2', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', cursor: 'pointer' }} onClick={() => navigate('/')}>
                                <img src="/logo-horizontal.png" alt="Evlo" style={{ height: '26px', objectFit: 'contain' }} onError={e => { e.target.style.display = 'none'; }} />
                            </div>
                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '4px 12px', borderRadius: '100px', background: 'rgba(124,58,237,0.08)', border: '1px solid rgba(124,58,237,0.2)', color: '#7c3aed', fontSize: '11px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                                <CrownIcon /> Super Admin
                            </div>
                        </div>

                        <div style={{ position: 'relative' }}>
                            <button
                                onClick={(e) => { e.stopPropagation(); setMenuOpen(!menuOpen); }}
                                style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '6px 12px', borderRadius: '12px', background: menuOpen ? '#f1f5f9' : '#ffffff', border: '1px solid #e2e8f0', cursor: 'pointer', transition: 'all 0.15s', fontFamily: 'inherit' }}
                            >
                                <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: 'linear-gradient(135deg, #a78bfa, #7c3aed)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 700, color: '#fff', flexShrink: 0 }}>
                                    {iniciais}
                                </div>
                                <div className="cm-nav-email" style={{ textAlign: 'left' }}>
                                    <p style={{ margin: 0, fontSize: '13px', fontWeight: 600, color: '#0f172a' }}>{nomeUsuario}</p>
                                    <p style={{ margin: 0, fontSize: '11px', color: '#94a3b8' }}>{emailUsuario}</p>
                                </div>
                                <span style={{ color: '#94a3b8', transition: 'transform 0.2s', transform: menuOpen ? 'rotate(180deg)' : 'none' }}><ChevronIcon /></span>
                            </button>

                            {menuOpen && (
                                <div style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, minWidth: '200px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '14px', boxShadow: '0 16px 48px rgba(0,0,0,0.1)', padding: '8px', zIndex: 100 }}>
                                    <button className="cm-menu-item" onClick={() => { navigate('/'); setMenuOpen(false); }}><HomeIcon /> Ir para Home</button>
                                    <div style={{ height: '1px', background: '#f1f5f9', margin: '6px 0' }} />
                                    <button className="cm-menu-item danger" onClick={handleLogout}><LogoutIcon /> Sair</button>
                                </div>
                            )}
                        </div>
                    </div>
                </header>

                {/* ── Hero gradiente ── */}
                <div style={{ background: 'linear-gradient(135deg, #0A1F3A 0%, #0d3d6e 55%, #0891b2 100%)', padding: '40px 24px 60px', position: 'relative', overflow: 'hidden' }}>
                    <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle at 15% 50%, rgba(255,255,255,0.07) 0%, transparent 50%), radial-gradient(circle at 85% 20%, rgba(255,255,255,0.05) 0%, transparent 40%)', pointerEvents: 'none' }} />
                    <div style={{ maxWidth: '1280px', margin: '0 auto', position: 'relative', zIndex: 1, opacity: mounted ? 1 : 0, transform: mounted ? 'translateY(0)' : 'translateY(16px)', transition: 'all 0.5s ease' }}>
                        <p style={{ margin: '0 0 8px', fontSize: '12px', fontWeight: 600, color: 'rgba(255,255,255,0.6)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
                            Super Admin
                        </p>
                        <h1 style={{ margin: '0 0 10px', fontSize: 'clamp(26px, 4vw, 38px)', fontWeight: 800, letterSpacing: '-0.03em', color: '#ffffff', lineHeight: 1.15 }}>
                            Gerenciamento de Clientes
                        </h1>
                        <p style={{ margin: 0, fontSize: '15px', color: 'rgba(255,255,255,0.6)', maxWidth: '480px', lineHeight: 1.6 }}>
                            Gerencie clientes e todos os usuários do sistema
                        </p>
                    </div>
                </div>

                {/* ── Conteúdo sobe sobre o hero ── */}
                <main style={{ maxWidth: '1280px', margin: '-24px auto 0', padding: '0 24px 80px', position: 'relative', zIndex: 1 }}>

                    {/* Card branco com tabs */}
                    <div style={{ background: '#ffffff', border: '1px solid #e8edf2', borderRadius: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.05)', overflow: 'hidden', opacity: mounted ? 1 : 0, transform: mounted ? 'translateY(0)' : 'translateY(16px)', transition: 'all 0.5s ease 0.08s' }}>

                        {/* Tabs header */}
                        <div style={{ display: 'flex', gap: '4px', padding: '14px 20px', borderBottom: '1px solid #f1f5f9', background: '#fafbfc' }}>
                            <button className={`cm-tab${activeTab === 'clientes' ? ' active' : ''}`} onClick={() => setActiveTab('clientes')}>
                                <BuildingIcon /> Clientes
                            </button>
                            <button className={`cm-tab${activeTab === 'usuarios' ? ' active' : ''}`} onClick={() => setActiveTab('usuarios')}>
                                <UsersIcon /> Usuários
                            </button>
                        </div>

                        {/* Conteúdo da tab */}
                        <div style={{ padding: '24px' }}>
                            {activeTab === 'clientes' && <GerenciarClientes supabase={supabase} />}
                            {activeTab === 'usuarios' && <GerenciarTodosUsuarios supabase={supabase} session={session} />}
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default ClientesMain;
